import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from "@angular/router";
import { isKnownExternalQuotesProvider } from "../features/cetelem-external-quotes/constants/external-quotes-providers.constants";

/**
 * Allows the generic external quotes portal (`:provider/clientes`) only for registered providers,
 * so an unknown segment never reaches the generic dashboard endpoint. The legacy `inbursa/clientes`
 * route is matched before this one and is not affected.
 */
@Injectable({
  providedIn: "root",
})
export class ExternalQuotesProviderGuard implements CanActivate {
  constructor(private readonly _router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const provider = route.paramMap.get("provider");
    if (isKnownExternalQuotesProvider(provider)) {
      return true;
    }
    return this._router.createUrlTree(["/"]);
  }
}
